import logo2009 from "../../assets/img/historicEvents/LogoBraggingRights/2009.png";
import logo2010 from "../../assets/img/historicEvents/LogoBraggingRights/2010.png";

export const braggingRightsDetail = {
  "bragging-rights": {
    id: "bragging-rights",
    title: "Bragging Rights",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "bragging-rights",
        items: [
          {
            id: "bragging-rights-2009",
            title: "Bragging Rights",
            description: "2009",
            imgUrl: logo2009,
          },
          {
            id: "bragging-rights-2010",
            title: "BraggiNg Rights",
            description: "2010",
            imgUrl: logo2010,
          },
        ],
      },
    ],
  },
};
